<template>
  <div class="reveal clearfix">
    <div>
      <img src="../../assets/zs-3.png" />
      <div>慈善榜样荣誉证书</div>
    </div>
    <div>
      <img src="../../assets/zs-4.png" />
      <div>慈善之星</div>
    </div>
    <div>
      <img src="../../assets/zs-2.png" />
      <div>苏州“慈善奖”荣誉证书</div>
    </div>
    <div>
      <img src="../../assets/zs-5.png" />
      <div>江苏慈善奖</div>
    </div>
    <div>
      <img src="../../assets/zs-1.png" />
      <div>中国社会组织评估等级证书</div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  name: 'about',
  components: {
  }
}
</script>